(() => {
  async function loadRecentlyViewed(scope = document) {
    const wrapper = scope.querySelector('[data-recently-viewed]');
    if (!wrapper || wrapper.dataset.loading) return;
    wrapper.dataset.loading = 'true';
    const grid = wrapper.querySelector('#recently-viewed-products');
    const cookie = document.cookie.split('; ').find(value => value.startsWith('shopify_recently_viewed='));
    let handles = [];
    try {
      handles = decodeURIComponent(cookie ? cookie.substring(cookie.indexOf('=') + 1) : '').split(/\s+/);
    } catch (_) { return; }
    handles = [...new Set(handles)].filter(handle => /^[a-z0-9-]+$/.test(handle) && handle !== wrapper.dataset.currentHandle).slice(0, 10);
    const root = wrapper.dataset.rootUrl.replace(/\/$/, '');
    const cards = await Promise.all(handles.map(async handle => {
      try {
        // Liquid renders the same metafields, prices and quick-add controls as every other grid.
        const response = await fetch(`${root}/products/${encodeURIComponent(handle)}?view=recently-viewed-card`);
        if (!response.ok) return null;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        return doc.querySelector('[data-recently-viewed-card]');
      } catch (_) { return null; }
    }));
    if (!wrapper.isConnected) return;
    cards.filter(Boolean).forEach(card => grid.appendChild(document.importNode(card, true)));
    if (!grid.children.length) return;
    wrapper.style.display = '';
    if (window.jQuery?.fn.owlCarousel) {
      window.jQuery(grid).owlCarousel({
        nav: true, dots: false, mouseDrag: true, loop: false,
        rtl: document.body.classList.contains('rtl'), items: 4,
        responsive: { 0: { items: 1 }, 480: { items: 2 }, 680: { items: 3 }, 1200: { items: 4 } }
      });
    } else {
      grid.style.display = 'grid';
      grid.style.gridTemplateColumns = 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))';
    }
    if (window.show_multiple_currencies && window.Currency && window.jQuery) {
      window.Currency.convertAll(window.shopCurrency, window.jQuery('[name=currencies]').val(), '#recently-viewed-products span.money');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadRecentlyViewed());
  } else {
    loadRecentlyViewed();
  }
  document.addEventListener('shopify:section:load', event => loadRecentlyViewed(event.target));
})();
